import { ExamGetForm } from "../exam/ExamListForm";
import Model from "@/lib/model/model";

export class StructParam {
  paramId?: 0;
  type = 0;
  isShow = 0;
  isRequired = 0;
  inputType?: "";
  sort = 0;
  extraData = "";
  name = "";
  value?: "";
  aliasName?: ""; //别名
}

export class StructCandidateData extends ExamGetForm {
  showName = "";
  phone = "";
  email = "";
  paramList: StructParam[] = new Array<StructParam>();
  tagList: string[] = [];
}

export default class CandidateCreateForm extends StructCandidateData {
  sendMessageTime = "";
  sendMessageType = 0;
  sendMessage: any = 0;
  tagList: string[] = [];
}

export class JobCreateForm extends Model {
  showName = "";
  phone = "";
  email = "";
  jobId = 0;
  sendMessage: any = 0;
  mobileMessageTemplateId = 0;
  emailMessageTemplateId = 0;
}
